import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap-trial/ScrollSmoother';
// import { CustomEase } from 'gsap/CustomEase';
// import horizontalLoop from './horizontalLoop';

// gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

// You must register the plugin before using it
// gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

export default function scrolling() {
  const headerButtons = document.querySelector('.js-header-buttons');
  //   const offerBanner = document.querySelector('.js-offer-banner');
  //   const repeatingSection = document.querySelector('.js-repeating-section');
  //   const repeatingLines = document.querySelectorAll('.js-repeating');

  //   const repeatingLine = document.querySelector('.js-single-repeating');
  const fixedBox = document.querySelector('.js-fixed-box');
  const mainNavigation = document.querySelector('.js-main-navigation');
  const roomsTab = document.querySelector('#rooms-tab');
  const accordionBtns = document.querySelectorAll('.js-accordion-btn');
  const faqsBtns = document.querySelectorAll('.js-faq-tab');
  const faqPanels = gsap.utils.toArray('.js-faq-panel');
  const getHeaderButtons = (count) => {

    //NOTE: redid in header.js without scrollSmoother

    // if (!headerButtons) {
    //   return false;
    // }
    //
    //
    // if (count > 50) {
    //   headerButtons.classList.add('is-active');
    // } else {
    //   headerButtons.classList.remove('is-active');
    // }
  };

  ///////////////
  //NOTE: IDK what to do with this

  // let smoother = ScrollSmoother.create({
  //   // smooth: 1,
  //   // smoothTouch: false,
  //   // ease: CustomEase.create("custom", "M0,0 C0.142,0.474 0.22,0.54 0.344,0.726 0.52,0.99 0.81,0.99 1,0.99 "),
  //   // effects: true,
  //
  //   smoothTouch: false,
  //
  //   smooth: 0.85,
  //   normalizeScroll: true,
  //   ignoreMobileResize: true,
  //   effects: true,
  //   preventDefault: true,
  //   ease: 'expo.out',
  //   onUpdate: (self) => {
  //     getHeaderButtons(self.scrollTop());
  //   },
  // });



  if (fixedBox) {
    gsap.utils.toArray(fixedBox).forEach((box) => {
      const getHeight = box.parentNode;
      ScrollTrigger.create({
        trigger: box,
        pin: true,
        start: 'top 50px',
        end: '+=' + (getHeight.offsetHeight - 250),
      });

      ScrollTrigger.normalizeScroll();
    });
  }

  // if(mainNavigation){
  // 	const mainNavElements = mainNavigation.querySelectorAll('.menu-item');
  // 	for(const element of mainNavElements){

  // 		const link = element.querySelector('a');
  // 		const wrapper = document.createElement('span');
  // 		const clone1 = link.cloneNode(true);
  // 		const clone2 = link.cloneNode(true);
  // 		const clone3 = link.cloneNode(true);
  // 		const clone4 = link.cloneNode(true);
  // 		const clone5 = link.cloneNode(true);
  // 		const clone6 = link.cloneNode(true);

  // 		wrapper.classList.add('elements-repeater');
  // 		wrapper.appendChild(clone1);
  // 		wrapper.appendChild(clone2);
  // 		wrapper.appendChild(clone3);
  // 		wrapper.appendChild(clone4);
  // 		wrapper.appendChild(clone5);
  // 		wrapper.appendChild(clone6);
  // 		element.appendChild(wrapper);

  // 		element.addEventListener('mouseenter', () => {
  // 			const link = element.children;
  // 			gsap.to(link[0], {
  // 				opacity: 0,
  // 				duration: 0
  // 			});
  // 			gsap.to(link[1], {
  // 				opacity: 1,
  // 				duration: 0
  // 			});
  // 		});

  // 		element.addEventListener('mouseleave', () => {
  // 			const link = element.children;
  // 			gsap.to(link[0], {
  // 				opacity: 1,
  // 				duration: 0
  // 			});
  // 			gsap.to(link[1], {
  // 				opacity: 0,
  // 				duration: 0
  // 			});
  // 		});

  // 	}

  // 	setTimeout(() => {
  // 		const getRepeaterElements = document.querySelectorAll('.elements-repeater');

  // 		for(const repeater of getRepeaterElements) {
  // 			const list = repeater.querySelectorAll('a');
  // 			horizontalLoop(list, {repeat: -1, reversed: true, speed: 1});
  // 		}
  // 	}, 1000);
  // }


  //TODO: Nezinau ar sito reikia

  // if (
  //   window.location.hash.substring(1) &&
  //   roomsTab &&
  //   window.location.hash != '#short'
  // ) {
  //   smoother.scrollTo(roomsTab);
  //   setTimeout(() => {
  //     ScrollTrigger.refresh();
  //     smoother.scrollTo(roomsTab);
  //   }, 400);
  // }

  if (accordionBtns) {
    for (const accordionBtn of accordionBtns) {
      accordionBtn.addEventListener('click', () => {
        setTimeout(() => {
          ScrollTrigger.refresh();
          // smoother.refresh();
        }, 500);
      });
    }
  }


  //TODO: remake this without smoother...
  if (faqsBtns) {
    for (const faqsBtn of faqsBtns) {
      faqsBtn.addEventListener('click', () => {
        const id = faqsBtn.getAttribute('data-id');
        // smoother.scrollTo('#' + id, true, 'top +=50px');

        gsap.to(window, {
          duration: 0.85,
          scrollTo: {
            y: '#' + id,
            offsetY: 50
          },
          ease: "expo.out",
          onUpdate: () => {
            getHeaderButtons(window.scrollY);
          }
        });

        for (const faqsActive of faqsBtns) {
          if (faqsActive.classList.contains('active-faq-tab')) {
            faqsActive.classList.remove('active-faq-tab');
          }
        }

        faqsBtn.classList.add('active-faq-tab');
      });
    }

    faqPanels.forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: 'top +=100',

        onEnter: () => {
          faqsBtns.forEach((e) => {
            e.classList.remove('active-faq-tab');
          });
          faqsBtns[i].classList.add('active-faq-tab');
        },
        onEnterBack: () => {
          faqsBtns.forEach((e) => {
            e.classList.remove('active-faq-tab');
          });
          faqsBtns[i].classList.add('active-faq-tab');
        },
      });
    });
  }


  // MOVED: TO HEADER.JS
  // if (roomsList) {
  //   addEventListener('scroll', () => {
  //     if (window.scrollY > roomsList.offsetTop) {
  //       document.body.classList.add('green-triggers');
  //     } else {
  //       document.body.classList.remove('green-triggers');
  //     }
  //   });
  // }

  // NOTE: IDK what to do with this
  // window.addEventListener('load', () => {
  //   ScrollTrigger.refresh();
  //   setTimeout(() => {
  //     smoother.refresh();
  //   }, 1000);
  // });
}
